import { inject, Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

export interface ToastOptions {
  summary?: string;
  detail?: string;
  life?: number;
  sticky?: boolean;
  key?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private readonly defaultLife = 3000;

  private messageService = inject(MessageService);

  /**
   * Show a success toast message
   */
  showSuccess(detail: string, summary: string = 'Success', options?: ToastOptions): void {
    this.messageService.add({
      severity: 'success',
      summary: options?.summary || summary,
      detail: options?.detail || detail,
      life: options?.life || this.defaultLife,
      sticky: options?.sticky || false,
      key: options?.key,
    });
  }

  /**
   * Show an error toast message
   */
  showError(detail: string, summary: string = 'Error', options?: ToastOptions): void {
    this.messageService.add({
      severity: 'error',
      summary: options?.summary || summary,
      detail: options?.detail || detail,
      life: options?.life || this.defaultLife,
      sticky: options?.sticky || false,
      key: options?.key,
    });
  }

  /**
   * Show an info toast message
   */
  showInfo(detail: string, summary: string = 'Info', options?: ToastOptions): void {
    this.messageService.add({
      severity: 'info',
      summary: options?.summary || summary,
      detail: options?.detail || detail,
      life: options?.life || this.defaultLife,
      sticky: options?.sticky || false,
      key: options?.key,
    });
  }

  /**
   * Show a warning toast message
   */
  showWarn(detail: string, summary: string = 'Warning', options?: ToastOptions): void {
    this.messageService.add({
      severity: 'warn',
      summary: options?.summary || summary,
      detail: options?.detail || detail,
      life: options?.life || this.defaultLife,
      sticky: options?.sticky || false,
      key: options?.key,
    });
  }

  /**
   * Clear all toast messages
   */
  clear(key?: string): void {
    this.messageService.clear(key);
  }
}
